// extracted by mini-css-extract-plugin
module.exports = {"block":"ArticleCondensed_block__2aYDp","title":"ArticleCondensed_title__XE5FE","lock":"ArticleCondensed_lock__jVxIv"};